(function () {
  const STORAGE_KEY = 'ci-wishlist.v1';

  function readWishlist() {
    if (window.CIWishlist && typeof window.CIWishlist.read === 'function') {
      return window.CIWishlist.read();
    }
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function formatMoney(cents, fallback) {
    if (fallback) return fallback;
    const amount = Number(cents) / 100;
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'COP',
        maximumFractionDigits: 0,
      }).format(amount);
    } catch (error) {
      return String(amount);
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildCard(item, product) {
    const title = product?.title || item.title || 'Producto';
    const handle = product?.handle || item.handle || '';
    const url =
      item.url ||
      (handle ? `/products/${handle}` : '#');
    const image =
      (product?.featured_image && String(product.featured_image)) ||
      item.image ||
      '';
    const price = product
      ? formatMoney(product.price)
      : item.price || '';
    const available = product ? product.available !== false : true;
    const productId = product?.id || item.id;
    const vendor = product?.vendor || item.vendor || '';

    const imageHtml = image
      ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(title)}" loading="lazy" width="600" height="600">`
      : '';

    const priceHtml = available && price
      ? `<p class="ci-pcard__price-wrap"><span class="ci-pcard__price ci-pcard__price--regular">${escapeHtml(price)}</span></p>`
      : '';

    const vendorHtml = vendor
      ? `<span class="ci-pcard__vendor">${escapeHtml(vendor)}</span>`
      : '';

    const mediaInner = image
      ? `<div class="ci-pcard__media"><img class="ci-pcard__media-img ci-pcard__media-img--primary" src="${escapeHtml(image)}" alt="${escapeHtml(title)}" loading="lazy" width="600" height="800"></div>`
      : `<div class="ci-pcard__media"><div class="ci-pcard__media-placeholder" aria-hidden="true"></div></div>`;

    return `
      <li class="ci-wl__item ci-pcard-wrap">
        <div class="ci-pcard ci-pcard--split${available ? '' : ' ci-pcard--sold-out'}">
          <div class="ci-pcard__inner ci-pcard__inner--has-favorite">
            <button
              type="button"
              class="ci-pcard__favorite is-active"
              data-ci-favorite-toggle
              data-product-id="${escapeHtml(productId)}"
              data-product-handle="${escapeHtml(handle)}"
              data-product-title="${escapeHtml(title)}"
              data-product-url="${escapeHtml(url)}"
              ${image ? `data-product-image="${escapeHtml(image)}"` : ''}
              ${vendor ? `data-product-vendor="${escapeHtml(vendor)}"` : ''}
              data-product-price="${escapeHtml(price)}"
              aria-pressed="true"
              aria-label="Quitar de favoritos: ${escapeHtml(title)}"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="m12 21-1.45-1.32C5.4 15.03 2 11.95 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.45-3.4 6.53-8.55 11.18z"/>
              </svg>
            </button>
            <a href="${escapeHtml(url)}" class="ci-pcard__media-link" aria-label="${escapeHtml(title)}">
              <div class="ci-pcard__media-wrap">${mediaInner}</div>
            </a>
            <div class="ci-pcard__info">
              <a href="${escapeHtml(url)}" class="ci-pcard__product-link" aria-label="${escapeHtml(title)}">
                ${vendorHtml}
                <h3 class="ci-pcard__product-title">${escapeHtml(title)}</h3>
                ${priceHtml}
              </a>
            </div>
          </div>
        </div>
      </li>
    `;
  }

  async function fetchProduct(handle) {
    if (!handle) return null;
    try {
      const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
        credentials: 'same-origin',
      });
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  async function renderSection(root) {
    const grid = root.querySelector('[data-ci-wishlist-grid]');
    const empty = root.querySelector('[data-ci-wishlist-empty]');
    const loading = root.querySelector('[data-ci-wishlist-loading]');
    if (!grid || !empty) return;

    const items = readWishlist();

    if (loading) loading.classList.remove('ci-wl__hidden');

    if (!items.length) {
      grid.innerHTML = '';
      grid.classList.add('ci-wl__hidden');
      empty.classList.remove('ci-wl__hidden');
      if (loading) loading.classList.add('ci-wl__hidden');
      return;
    }

    empty.classList.add('ci-wl__hidden');
    grid.classList.remove('ci-wl__hidden');

    const cards = await Promise.all(
      items.map(async (item) => {
        const product = await fetchProduct(item.handle);
        return buildCard(item, product);
      })
    );

    grid.innerHTML = cards.join('');
    if (loading) loading.classList.add('ci-wl__hidden');

    if (window.CIWishlist && typeof window.CIWishlist.sync === 'function') {
      window.CIWishlist.sync(grid);
    }
  }

  function init() {
    document.querySelectorAll('[data-ci-wishlist-page]').forEach((root) => {
      renderSection(root);
    });
  }

  document.addEventListener('ci:wishlist:change', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target && event.target.querySelector('[data-ci-wishlist-page]');
    if (root) renderSection(root.closest('[data-ci-wishlist-page]') || event.target);
  });
})();
